<template>
  <div class="uni-data-pickerview">
    <scroll-view class="selected-area" scroll-x="true">
      <div class="selected-list">
        <div
          v-for="(item, index) in selected"
          v-if="item.text"
          :key="index"
          class="selected-item"
          :class="{ 'selected-item-active': index == selectedIndex }"
          @click="handleSelect(index)"
        >
          <span class="">{{ item.text }}</span>
        </div>
      </div>
    </scroll-view>
    <div class="tab-c">
      <scroll-view
        v-for="(child, i) in dataList"
        v-if="i == selectedIndex"
        :key="i"
        class="list"
        scroll-y="false"
      >
        <div v-for="(item, j) in child" :key="j" class="item" @click="handleNodeClick(i, j)">
          <span class="item-text">{{ item.text }}</span>
          <div v-if="selected.length > i && item.value == selected[i].value" class="check" />
        </div>
      </scroll-view>
      <div v-if="loading" class="loading-cover">
        <uni-load-more class="load-more" :contentText="loadMore" status="loading" />
      </div>
      <div v-if="errorMessage" class="error-message">
        <span class="error-text">{{ errorMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import dataPicker from './uni-data-picker.js'

/**
 * uni-data-pickerview
 * @description uni-data-pickerview
 * @tutorial https://uniapp.dcloud.net.cn/uniCloud/uni-data-picker
 * @property {Array} localdata 本地数据，参考
 * @property {Boolean} step-searh = [true|false] 是否分布查询
 * @value true 启用分布查询，仅查询当前选中节点
 * @value false 关闭分布查询，一次查询出所有数据
 * @property {String|DBFieldString} self-field 分布查询当前字段名称
 * @property {String|DBFieldString} parent-field 分布查询父字段名称
 * @property {String|DBCollectionString} collection 表名
 * @property {String|DBFieldString} field 查询字段，多个字段用 `,` 分割
 * @property {String} orderby 排序字段及正序倒叙设置
 * @property {String|JQLString} where 查询条件
 */
export default {
  name: 'UniDataPickerView',
  mixins: [dataPicker],
  props: {
    managedMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  created() {
    if (this.managedMode) {
      return
    }

    this.$nextTick(() => {
      this.load()
    })
  },
  methods: {
    onPropsChange() {
      this._treeData = []
      this.selectedIndex = 0
      this.load()
    },
    load() {
      if (this.isLocaldata) {
        this.loadData()
      } else if (this.value.length) {
        this.getTreePath(res => {
          this.loadData()
        })
      }
    },
    handleSelect(index) {
      this.selectedIndex = index
    },
    handleNodeClick(i, j) {
      const node = this.dataList[i][j]
      const { value, text } = node

      if (i < this.selected.length - 1) {
        this.selected.splice(i, this.selected.length - i)
        this.selected.push(node)
      } else if (i === this.selected.length - 1) {
        this.selected[i] = node
      }

      if (node.isLeaf) {
        this.onSelectedChange(node, node.isLeaf)
        return
      }

      const { isLeaf, hasNodes } = this._updateBindData()

      if (this.isLocaldata && (!hasNodes || isLeaf)) {
        this.onSelectedChange(node, true)
        return
      }

      if (!isLeaf && !hasNodes) {
        this._loadNodeData(data => {
          if (!data.length) {
            node.isLeaf = true
          } else {
            this._treeData.push(...data)
            this._updateBindData(node)
          }
          this.onSelectedChange(node, node.isLeaf)
        }, this.nodeWhere)
        return
      }

      this.onSelectedChange(node, false)
    },
    updateData(data) {
      this._treeData = data.treeData
      this.selected = data.selected
      if (!this._treeData.length) {
        this.loadData()
      } else {
        //this.selected = data.selected
        this._updateBindData()
      }
    },
    onDataChange() {
      this.$emit('datachange')
    },
    onSelectedChange(node, isLeaf) {
      if (isLeaf) {
        this._dispatchEvent()
      } else if (node) {
        this.$emit('nodeclick', node)
      }
    },
    _dispatchEvent() {
      this.$emit('change', this.selected.slice(0))
    }
  }
}
</script>

<style scoped>
.uni-data-pickerview {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.error-text {
  color: #dd524d;
}

.loading-cover {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1001;
}

.load-more {
  margin: auto;
}

.error-message {
  background-color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 0.32rem;
  opacity: 0.9;
  z-index: 102;
}

.selected-list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 0 0.106667rem;
  border-bottom: 0.021333rem solid #f8f8f8;
}

.selected-item {
  margin-left: 0.213333rem;
  margin-right: 0.213333rem;
  padding: 0.256rem 0;
}

.selected-item-active {
  border-bottom: 0.042667rem solid #007aff;
}

.selected-item-text {
  color: #007aff;
}

.tab-c {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

.list {
  flex: 1;
  height: 100%;
}

.item {
  padding: 0.256rem 0.32rem;
  border-bottom: 0.021333rem solid #f0f0f0;
  display: flex;
  flex-direction: row;
}

.item-text {
  flex: 1;
  color: #333333;
}

.check {
  margin-right: 0.106667rem;
  border: 0.042667rem solid #007aff;
  border-left: 0;
  border-top: 0;
  height: 0.256rem;
  width: 0.128rem;
  transform-origin: center;
  transition: all 0.3s;
  transform: rotate(45deg);
}
</style>
